import { Injector, Provider } from '@angular/core';

import { ApModalHelperBase } from './ApModalHelperBase';

export abstract class ApModalHelperFactoryBase {
  // shortcut to provide a subclass of ApModalHelperFactoryBase as ApModalHelperFactoryBase
  static provideAsBase(): Provider {
    return {
      provide: ApModalHelperFactoryBase,
      useExisting: this,
    };
  }

  // This should be the injector from the component, not an Injector
  // injected directly into a service.
  abstract create<T>(elementInjector: Injector, hideHandler: (reason: string) => void): ApModalHelperBase<T>;
}
